import { render, staticRenderFns } from "./UserCtas.vue?vue&type=template&id=00fcc469"
import script from "./UserCtas.vue?vue&type=script&lang=js"
export * from "./UserCtas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports